import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, ReorderModeSchema, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"
import { moveToNewSectionTransition } from "../transitionalStates"

export const reorderModeState: StateNodeConfig<
  Context,
  ReorderModeSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    isReorderMode: true,
    selectedLessonId: null,
    selectedSectionId: null
  }),
  initial: "idle",
  states: {
    idle: {
      on: {
        SAVE: {
          target: "#StudyPlan.save_study_plan_transition"
        },
        CANCEL: {
          target: "#StudyPlan.edit_plan.confirm_leave",
          actions: assign<Context>({
            isReorderMode: false
          })
        },
        DRAG_DROP_MOVE_OUT_SECTION: {
          target: "move_to_new_section_modal",
          actions: assign((_ctx, { sectionId, lessonId }) => ({
            selectedSectionId: sectionId,
            selectedLessonId: lessonId
          }))
        },
        DRAG_DROP_ITEM: {
          target: "reorder_section_item_transition"
        },
        DRAG_DROP_SECTION: {
          target: "reorder_section_transition"
        },
        END_REORDER: {
          target: "#StudyPlan.edit_plan",
          actions: assign<Context>({
            isReorderMode: false
          })
        },
        EXPAND_ALL: {
          actions: assign((ctx, _evt) => ({
            expanded: ctx.studyPlan.sections.map(({ id }) => id)
          }))
        },
        COLLAPSE_ALL: {
          actions: assign((_ctx, _evt) => ({ expanded: [] }))
        },
        UNDO: {
          target: "#StudyPlan.undo_transition"
        },
        REDO: {
          target: "#StudyPlan.redo_transition"
        },

        ADD_MASTERY_LESSON_SECTION: {
          target: "#StudyPlan.add_section_transition",
          cond: ctx =>
            ctx.studyPlan.meta.canAddMasteryLesson === true &&
            ctx.studyPlan.meta.remainingMasteryContentSeconds > 0
        },
        ADD_PRACTICE_TEST_SECTION: {
          target: "#StudyPlan.add_section_transition",
          cond: ctx =>
            ctx.studyPlan.meta.canAddPracticeTest === true &&
            ctx.studyPlan.meta.remainingPracticeTestContentSeconds > 0
        }
      }
    },
    move_to_new_section_transition: { ...moveToNewSectionTransition },

    //// this is not a transition
    // prior move_to_new_section_transition re-named to move_to_new_section_modal
    //
    move_to_new_section_modal: {
      entry: assign<Context>({ moveOutOfSectionModal: true }),
      exit: assign<Context>({
        moveOutOfSectionModal: false
      }),
      on: {
        DRAG_DROP_MOVE_OUT_SECTION_CONFIRM: {
          target: "move_to_new_section_transition"
        },
        CANCEL: {
          target: "idle",
          actions: assign<Context>({
            selectedLessonId: null,
            selectedSectionId: null
          })
        }
      }
    },
    reorder_section_item_transition: {
      invoke: {
        src: "reorderSectionItem",
        onDone: {
          target: "idle",
          actions: assign({ studyPlan: (_ctx, evt) => evt.data.plan })
        },
        onError: {
          target: "idle",
          actions: assign<Context, DoneInvokeEvent<any>>({
            snackbar: (_ctx, evt) => ({
              message: getServiceErrorMessage("reorderSectionItem", {
                errorReason: evt.data.message,
                messageData: ["reorder item"]
              }),
              withUndo: false,
              error: true
            })
          })
        }
      }
    },
    reorder_section_transition: {
      invoke: {
        src: "reorderSection",
        onDone: {
          target: "idle",
          actions: assign({ studyPlan: (_ctx, evt) => evt.data.plan })
        },
        onError: {
          target: "idle",
          actions: assign<Context, DoneInvokeEvent<any>>({
            snackbar: (_ctx, evt) => ({
              message: getServiceErrorMessage("reorderSection", {
                errorReason: evt.data.message,
                messageData: ["reorder section"]
              }),
              withUndo: false,
              error: true
            })
          })
        }
      }
    }
  }
}
